module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.f1591ab.ttf";